import { supabase } from '../supabaseClient';
import { normalizeInviteEmail } from '../config/collaborationPolicy';

export const COLLABORATION_CHANGED = 'climorax:collaboration-changed';
export const COLLABORATION_SETUP_MESSAGE = 'Colaboração e Equipe aguardam a ativação segura do banco nesta versão. Nenhum acesso foi alterado.';

async function rpc(name, args) {
  const { data, error } = await supabase.rpc(name, args);
  if (error) {
    if (['PGRST202', '42883', '42P01'].includes(error.code)) throw new Error(COLLABORATION_SETUP_MESSAGE);
    throw new Error(error.message || 'Não foi possível concluir a operação de colaboração.');
  }
  return data;
}
function changed() { window.dispatchEvent(new Event(COLLABORATION_CHANGED)); }
export const loadCollaboration = () => rpc('collaboration_snapshot');
export const checkSharedPlotCapacity = propertyId => rpc('collaboration_check_plot_capacity', { p_property: propertyId });
export async function createCollaborationInvite({ ownerId, email, role, propertyIds, permissions, kind }) {
  const data = await rpc('collaboration_invite', {
    p_owner: ownerId, p_email: normalizeInviteEmail(email), p_role: role,
    p_properties: propertyIds, p_permissions: permissions, p_kind: kind,
  });
  changed();
  return data;
}
export async function respondCollaborationInvite(id, accept, token = null) {
  const data = await rpc('collaboration_respond', { p_id: id, p_accept: accept, p_token: token });
  changed();
  return data;
}
export async function revokeCollaborationInvite(id) {
  const data = await rpc('collaboration_revoke', { p_id: id });
  changed();
  return data;
}
export async function revokeLegacyCollaboration(propertyId, userId) {
  await rpc('collaboration_revoke_legacy', { p_property: propertyId, p_user: userId });
  changed();
}
export async function updateCollaborationInvite(id, role, permissions) {
  const data = await rpc('collaboration_update_access', { p_id: id, p_role: role, p_permissions: permissions });
  changed();
  return data;
}
export function invitationLink(id, token) {
  const url = new URL(window.location.origin);
  // Fragmento não é enviado ao servidor nem incluído em Referer.
  url.hash = new URLSearchParams({ collaboration: id, invitation: token }).toString();
  return url.toString();
}
export async function sendCollaborationEmail(id, token) {
  const { data, error } = await supabase.functions.invoke('enviar-convite', {
    body: { invitationId: id, token, appUrl: window.location.origin },
  });
  if (error || !data?.ok) throw new Error('Convite criado, mas o e-mail não foi entregue. Use o link privado ou confira a configuração de envio.');
  return data;
}
